import React from 'react';
import { ClockIcon, InfoIcon, DollarSignIcon } from 'lucide-react';
export function ScheduleFees() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2098">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2099">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-2100">
          {/* Schedule Card */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2101">
            <div className="flex items-center gap-3 mb-6" data-id="element-2102">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
              backgroundColor: 'rgba(30,61,47,0.08)'
            }} data-id="element-2103">
                <ClockIcon size={20} style={{
                color: '#1e3d2f'
              }} data-id="element-2104" />
              </div>
              <h2 className="text-2xl font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-2105">
                Schedule
              </h2>
            </div>

            <div className="space-y-4" data-id="element-2106">
              <p className="text-base" style={{
              color: '#2a2a2a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2107">
                The team meets{' '}
                <strong data-id="element-2108">5:30 to 9:30 pm on Tuesday evenings</strong> during the
                school year.
              </p>
              <div className="flex items-start gap-3 p-4 rounded-lg" style={{
              backgroundColor: '#f0f7f3'
            }} data-id="element-2109">
                <InfoIcon size={18} className="flex-shrink-0 mt-0.5" style={{
                color: '#2d5a3d'
              }} data-id="element-2110" />
                <p className="text-sm" style={{
                color: '#2d5a3d',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-2111">
                  Actual range time is about one hour. Shooters will be assigned
                  to a specific session: 5:30-6:30, 6:30-7:30, 7:30-8:30, or
                  8:30-9:30.
                </p>
              </div>
            </div>
          </div>

          {/* Fees Card */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2112">
            <div className="flex items-center gap-3 mb-6" data-id="element-2113">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
              backgroundColor: 'rgba(200,168,75,0.15)'
            }} data-id="element-2114">
                <DollarSignIcon size={20} style={{
                color: '#c8a84b'
              }} data-id="element-2115" />
              </div>
              <h2 className="text-2xl font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-2116">
                Fees & Membership
              </h2>
            </div>

            <div className="space-y-4" data-id="element-2117">
              <p className="text-base font-medium" style={{
              color: '#1e3d2f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2118">
                Parents do not have to be club members for children to
                participate.
              </p>
              <ul className="space-y-3" data-id="element-2119">
                <li className="flex items-center justify-between border-b pb-2" style={{
                borderColor: '#ede9e0'
              }} data-id="element-2120">
                  <span className="text-sm" style={{
                  color: '#4a4a4a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2121">
                    Annual League Fee (includes junior membership)
                  </span>
                  <span className="font-bold" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2122">
                    $40.00
                  </span>
                </li>
                <li className="flex items-center justify-between border-b pb-2" style={{
                borderColor: '#ede9e0'
              }} data-id="element-2123">
                  <span className="text-sm" style={{
                  color: '#4a4a4a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2124">
                    Nightly Shooting Fee
                  </span>
                  <span className="font-bold" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2125">
                    $6.00
                  </span>
                </li>
                <li className="flex items-center justify-between pt-1" data-id="element-2126">
                  <span className="text-sm font-semibold" style={{
                  color: '#c8a84b',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2127">
                    First Night
                  </span>
                  <span className="font-bold uppercase text-sm" style={{
                  color: '#c8a84b',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2128">
                    Free
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}